let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("32gue")).then(() => parcelRequire('b9jOK'));